import { render, staticRenderFns } from "./FormularioEstornar.vue?vue&type=template&id=0d52cfd8"
import script from "./FormularioEstornar.vue?vue&type=script&lang=js"
export * from "./FormularioEstornar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports